export const officeLocationQueryKeys = {
  GET_OFFICE_LOCATIONS_NON_PRIMARY: 'GET_OFFICE_LOCATIONS_NON_PRIMARY',
  GET_OFFICE_LOCATIONS_PRIMARY: 'GET_OFFICE_LOCATIONS_PRIMARY',
  GET_OFFICE_LOCATIONS: 'GET_OFFICE_LOCATIONS',
};
